import React, { useState } from 'react'; // Добавлен импорт useState
import { LazyLoadImage } from 'react-lazy-load-image-component';

function Modal({ src, title, tech, desc, fulldesc, isOpen, onClose }) {

    // const mailLink = 'mailto:pretpiro@gmail.com?subject=' + title;

    const [isClosing, setIsClosing] = useState(false);

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            setIsClosing(false);
            onClose();
        }, 300); // Длительность анимации исчезновения
    };

    if (!isOpen && !isClosing) return null;


    // Добавьте функцию санитизации
    const sanitizeHtml = (html) => {
        if (!html) return '';
        
        // Базовая очистка от опасных скриптов
        return html
            .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
            .replace(/javascript:/gi, '')
            .replace(/on\w+="[^"]*"/gi, '')
            .replace(/on\w+='[^']*'/gi, '');
    };

    const createMarkup = (htmlContent) => {
        return { __html: sanitizeHtml(htmlContent) };
    };

    return (
        <div className="modal-overlay" onClick={handleClose}>
            <div className={`modal-content ${isClosing ? 'closing' : ''}`} onClick={e => e.stopPropagation()}>
                {/* <div>
                    <LazyLoadImage src={src} alt={title} effect="blur" className='modal-img'/>
                </div> */}
                <div>
                    <span className="close-button" onClick={handleClose}>&times;</span>
                    <h2>{title}</h2>
                    <div className='tags'>{tech}</div>
                    {fulldesc && (
                        <div 
                            className='fdescr'
                            dangerouslySetInnerHTML={createMarkup(fulldesc)}
                        />
                    )}
                    <div className='tags'>{desc}</div>
                </div>
            </div>
        </div>
    );
}

export default Modal;